import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import Styles from "../../assets/css/Pages/CustomerSupport.module.css";
import { Helmet } from "react-helmet-async";
// Loaders
import Loading from "../Loadings/Loading";
// Global Imports
import { useGlobalState } from "../../Functions/GlobalStates";

const CustomerSupport = () => {
  // States Here
  const [IsLoaded, setIsLoaded] = useState(false); // I CAN use this to show loading before all images loads
  // Global States Here //////////////////////////////////////////////////////...............................
  const {
    CheckPage,
    setCheckPage,
    DontAllow,
    setDontAllow,
    PagesWidthHeight,
    setPagesWidthHeight,
  } = useGlobalState();

  // React Referrences
  const CheckPageStateRef = useRef(false); // Ref for the check Page

  // Show And Hide Navbar DropMenu HomePage
  useEffect(() => {
    const handleCheckResize = () => {
      if (!CheckPageStateRef.current) {
        CheckPageStateRef.current = true;
        setCheckPage(true);
        setDontAllow(true);
      }
      // console.log("oN Mount", CheckPageStateRef.current);
      // console.log("Mounted User Entered");
    };
    handleCheckResize(); // call on mount

    // Add the resize event listener
    window.addEventListener("resize", handleCheckResize);

    // Update global state when the component unmounts , It mean when The user Leaves This Page
    return () => {
      if (CheckPageStateRef.current) {
        CheckPageStateRef.current = false;
        setCheckPage(true);
        setDontAllow(false);
      }
      // console.log("oN unMOUNT", CheckPageStateRef.current);
      // console.log("Unmounted User Leaved");
      window.removeEventListener("resize", handleCheckResize);
    };
  }, []);

  const PagesImages = require.context(
    "../../assets/images/Pages/CustomerSupport/Ai-Images",
    false,
    /\.(png|jpe?g|gif|bmp|webp|svg|avif)$/
  );
  const PageImages = [
    PagesImages("./1.avif"),
    PagesImages("./2.avif"),
    PagesImages("./3.avif"),
    PagesImages("./4.avif"),
    PagesImages("./5.avif"),
  ];

  // Preload Images Before render it will help to descrease flickers on img change
  useEffect(() => {
    const preloadImages = async (imageArray, callback) => {
      try {
        await Promise.all(
          imageArray.map((src) => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = src;
              img.onload = resolve;
              img.onerror = reject; // Add error handling
            });
          })
        );
        callback(); // Callback after all images are preloaded
      } catch (error) {
        console.error("Error preloading image:", error);
      }
    };

    preloadImages([PageImages[0]], () => {
      setIsLoaded(true); // Set state when all images are loaded
      // console.log("All Images Are Loaded");
    });
  });

  return IsLoaded ? (
    <><Helmet>
      {/* Page Title */}
      <title>Customer Support – Affiliators 📞</title>

      {/* Meta Description */}
      <meta
        name="description"
        content="Need help? Contact Affiliators Customer Support for quick assistance with your e-commerce questions and issues."
      />

      {/* Keywords */}
      <meta
        name="keywords"
        content="customer support, help center, contact support, ecommerce assistance"
      />

      {/* Responsive Design */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      {/* Open Graph Tags */}
      <meta property="og:title" content="Customer Support – Affiliators 📞" />
      <meta
        property="og:description"
        content="Reach out to Affiliators support for fast solutions to your online business needs."
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content="https://affiliators.netlify.app/#/customersupport"
      />

      {/* Image Meta Tags for Social Sharing */}
      {/*
    <meta
      property="og:image"
      content="/images/support/customersupport.png"
    />
    <meta
      name="twitter:image"
      content="/images/support/customersupport.png"
    />
    */}

      {/* Twitter Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Customer Support – Affiliators 📞" />
      <meta
        name="twitter:description"
        content="We're here to help. Contact Affiliators Customer Support for assistance."
      />

      {/* Indexing and Canonical URL */}
      <meta name="robots" content="index, follow" />
      {/* <link
        rel="canonical"
        href="https://affiliators.netlify.app/#/customersupport"
      /> */}

      {/* Author and Language */}
      <meta name="author" content="Zeeshan Ahmad Kamran" />
      <meta name="language" content="en" />
      <meta httpEquiv="Content-Language" content="en" />
    </Helmet>

      <div className={Styles.CustomerSupportContainer}>
        <section className={Styles.CustomerSupportSection1}>
          <h1>Customer Support</h1>
          <div className={Styles.CustomerSupportSection1ImgPara1Container}>
            <img src={PageImages[0]} alt="Welcome To My Website" />
            <p>
              We are here to assist you with any questions or concerns related to
              our recommended products and blog content. Your satisfaction and
              clarity are important to us.
            </p>
          </div>
          <div className={Styles.CustomerSupportSection1HeadingImgPara1Container}>
            <h2>How We Can Help</h2>
            <div className={Styles.CustomerSupportSection1ImgPara2Container}>
              <img src={PageImages[1]} alt="Welcome To My Website" />
              <p>
                If you have inquiries regarding our blog posts, product
                recommendations, or need assistance with any of the items
                mentioned, please feel free to contact us.
              </p>
            </div>
          </div>
          <div className={Styles.CustomerSupportSection1HeadingImgPara2Container}>
            <h2>Contact Information</h2>
            <div className={Styles.CustomerSupportSection1ImgPara3Container}>
              <img src={PageImages[2]} alt="Welcome To My Website" />
              <p>
                <strong>Email:</strong> <span>emailsforhosting@gmail.com</span>
                &nbsp;
                <strong>Phone:</strong> <span>+92-319-430-0261</span>
              </p>
            </div>
          </div>
          <div className={Styles.CustomerSupportSection1HeadingImgPara3Container}>
            <h2>Important Note</h2>
            <div className={Styles.CustomerSupportSection1ImgPara4Container}>
              <img src={PageImages[3]} alt="Welcome To My Website" />
              <p>
                Our support services are limited to inquiries about the products
                and services we discuss on our blog. We do not collect or store
                any personal information, and our recommendations are based on
                independent research and affiliate partnerships in compliance with
                affiliate program guidelines.
              </p>
            </div>
          </div>
          <div className={Styles.CustomerSupportSection1HeadingImgPara4Container}>
            <h2>Thank You 🫱🏼‍🫲🏻✨</h2>
            <div className={Styles.CustomerSupportSection1ImgPara5Container}>
              <img src={PageImages[4]} alt="Welcome To My Website" />
              <p>
                Thank you for visiting Bloggers.com. We look forward to assisting
                you💖
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  ) : (
    <Loading />
  );
};

export default CustomerSupport;
